<template>
<div>
  <div v-show="useTcPlayer && !flashSuport.f&&(!this.inPlayer ||!this.inPlayer.swf)" class="tips">
    <p>Sorry, your flash plugin isn't working appropriately to play the video.</p>
    <a href="//www.adobe.com/go/getflashplayer" target="_blank" class="txt first">Restore the FLASH plugin <em>( recommended)</em></a>
  </div>
  <div class="response-player" :id="playerId" :class="{'is-out-course': outCourse}" :style="{paddingTop:(1/ratio*100)+'%'}"></div>
</div>
</template>

<script type="text/ecmascript-6">
// ie 11不支持
// const isIe11 = navigator.userAgent.indexOf('rv:11.0') >= 0
// hls 和 flv 腾讯云提供海外节点加速
// tcplayer支持多语言定制
let useTcPlayer = true
let jsPath = '//qzonestyle.gtimg.cn/open/qcloud/video/live/h5/live_connect.js'
if (useTcPlayer) {
  jsPath = '//imgcache.qq.com/open/qcloud/video/vcplayer/TcPlayer-2.3.2.js'
}
const wording = {
  1: 'Network error, please check your network configuration or your video resource link.',
  2: 'Network error, please try later.',
  3: 'Sorry, can\'t decode the video.',
  4: 'The fomat of video is not supported in this system environment.',
  5: 'The fomat of video is not supported in this system environment. Please check whether the FLASH plugin is in working or not.',
  10: 'Please do not use the video player in file protocol, or the video can\'t be played.',
  11: 'Parameter error, please check the js code.',
  12: 'Please use the URL link of the video to play.',
  13: 'Live is over, see you the next lesson.',
  1001: 'Network error, the connection was closed, please check the configration or your video resource link.',
  1002: 'Can not get the video, maybe the video resource didn\'t exit or the server was in error.',
  2032: 'Can not get the video, please check whether the URL of the video resource is valid.',
  2048: 'Can not load the video file because of cross-domain accessing. The reason for failing to request the M3U8 file may be cross-domain accessing or network error.'
}

export default {
  name: 'in-player',
  props: {
    width: Number,
    height: Number,
    // maxWidth: Number,
    ratio: Number,
    liveUrls: Array,
    outCourse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      useTcPlayer: useTcPlayer,
      defaultWidth: 1024,
      defaultHeight: 768,
      playerId: 'live-video',
      // 播放器实例
      inPlayer: null,
      defaultOption: {
        app_id: '1251825884',
        lang: 'en',
        width: '1024',
        height: '768',
        https: '1',
        bgcolor: '#52545a',
        x5_type: 'h5',
        x5_fullscreen: 'true',
        VMode: 'transparent',
        x5_orientation: 0
      },
      clickDelayTimer: null,
      flashSuport: this.flashChecker()
    }
  },
  watch: {
    realWidth (value) {
      if (this.inPlayer && !this.outCourse) {
        this.inPlayer.setPlayerSize(value, this.realHeight)
      }
    },
    realHeight (value) {
      if (this.inPlayer && !this.outCourse) {
        this.inPlayer.setPlayerSize(this.realWidth, value)
      }
    }
  },
  computed: {
    realWidth () {
      return this.outCourse ? 'unset' : `${(this.width || this.defaultWidth)}px`
    },
    realHeight () {
      return this.outCourse ? 'unset' : `${(this.height || this.defaultHeight)}px`
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.liveUrls) {
        this._initialize()
      }
    })
  },
  methods: {
    _initialize () {
      // 判断播放器全局实例是否已存在，只有当播放器依赖的 JS 加载完成后，播放器的全局实例才存在
      // if (!window.qcVideo) {
      if (!window.TcPlayer) {
        let inPlayerScriptTag = document.getElementById('tcLivePlayerScriptTag')

        // 判断JS是否已存在
        if (!inPlayerScriptTag) {
          inPlayerScriptTag = document.createElement('script')
          inPlayerScriptTag.type = 'text/javascript'
          inPlayerScriptTag.src = jsPath
          // 指定 JS 的 ID
          inPlayerScriptTag.id = 'tcLivePlayerScriptTag'

          let head = document.getElementsByTagName('head')[0]
          head.appendChild(inPlayerScriptTag)
        }

        if (inPlayerScriptTag.loaded) {
          this._initPlayer()
        } else {
          inPlayerScriptTag.addEventListener('load', () => {
            this._initPlayer()
          })
        }
      } else {
        this._initPlayer()
      }
    },
    _initPlayer () {
      if (!this.inPlayer) {
        try {
          this._initPlayerInstance()
        } catch (error) {
          console.error(error)
        }
      } else {
        const a = document.getElementById(this.playerId).getElementsByTagName('video')
        if (a && a[0]) {
          // a[0].removeEventListener('click', this.clickVideo)
          // a[0].removeEventListener('dblclick', this.dblClickVideo)
          this.inPlayer = null
          document.getElementById(this.playerId).innerHTML = ''
        }

        // 再次初始化
        this._initPlayer()
      }
    },
    _initPlayerInstance () {
      const params = Object.assign({}, this.defaultOption, {
        id: this.playerId,
        width: this.realWidth,
        height: this.realHeight,
        // live_url1: this.liveUrls[0],
        live_url: this.liveUrls[1],
        live_url2: this.liveUrls[2]
      })
      if (useTcPlayer) {
        this.inPlayer = this._insTcPlayer(params)
      } else {
        this.inPlayer = new window.qcVideo.Player(this.playerId, params)
        this.inPlayer.destroy = () => {

        }
        this.inPlayer.options = params
        this.inPlayer.load = () => {
          this.inPlayer.play()
        }
        this.inPlayer.listeners = {
          playStatus: (status) => {
            if (status === 'error' || status === 'playEnd') {
            // _this.chatModel.liveStatusChange(status);
            }
            console.log('live status: ' + status)
            if (status.trim() === 'error') {
              this.$emit(status.trim())
            } else if (status.trim() === 'ready') {
              this.$emit('load', this.inPlayer)
              this.$emit('loadeddata', this.inPlayer)
            } else {
              this.$emit(status.trim())
            }
            if (status === 'ready') {
              // this.inPlayer.play()
            }
          }
        }
      }
    },
    _insTcPlayer (params) {
      try {
        let player = new window.TcPlayer(params.id, {
          autoplay: true,
          flash: false,
          systemFullscreen: true,
          h5_flv: true,
          x5_player: true, // 安卓微信， qq浏览器
          clarityLabel: { od: 'OD', hd: 'HD', sd: 'SD' },
          width: params.width, // 视频的显示宽度，请尽量使用视频分辨率宽度
          height: params.height,
          rtmp: params.live_url1,
          flv: params.live_url.replace(/https:/, ''),
          m3u8: params.live_url2.replace(/https:/, ''),
          wording: wording,
          live: true,
          listener: ({ src, type }) => {
          // h5: load loadedmetadata volumechange loadeddata seeking  timeupdate seeked  resize progress
          // flash: load loadedmetadata volumechange
            if (type === 'timeupdate' || type === 'resize') {
              return false
            }
            if (type === 'error') {
              this.$emit('error')
              console.log('live status: ' + type)
            } else if (type === 'load') {
              this.$emit('load', player)
              console.log('live status: ' + type)
            } else {
              this.$emit(type)
            }
          }
        })
        return player
      } catch (error) {

      }
    },
    // 更新播放地址
    changePlayAuth () {
      // 重新初始化
      this._initPlayer()
    },
    clickVideo (e) {
      let a = this.inPlayer.getStatus()
      if (a === 'ready' || a === 'pause' || a === 'ended') {
        this.play(a)
      } else if (a === 'playing') {
        this.pause()
      }
    },
    dblClickVideo (e) {
      clearTimeout(this.clickDelayTimer)
      if (this.inPlayer) {
        if (this.inPlayer.fullscreenService.getIsFullScreen()) {
          this.inPlayer.fullscreenService.cancelFullScreen()
        } else {
          this.inPlayer.fullscreenService.requestFullScreen()
        }
      }
    },
    flashChecker: function () {
      let hasFlash = 0
      let flashVersion = 0
      if (document.all) {
        let swf = new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash')
        if (swf) {
          hasFlash = 1
          let VSwf = swf.GetVariable('$version')
          flashVersion = parseInt(VSwf.split(' ')[1].split(',')[0])
        }
      } else {
        if (navigator.plugins && navigator.plugins.length > 0) {
          let swf = navigator.plugins['Shockwave Flash']
          if (swf) {
            hasFlash = 1
            let words = swf.description.split(' ')
            for (let i = 0; i < words.length; ++i) {
              if (isNaN(parseInt(words[i]))) continue
              flashVersion = parseInt(words[i])
            }
          }
        }
      }
      return {
        f: hasFlash,
        v: flashVersion
      }
    }
  },
  beforeDestroy () {
  },
  destroyed () {
    if (this.inPlayer && this.inPlayer.el.length) {
      this.inPlayer.destroy()
      this.inPlayer = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .response-player{
    margin: 0 auto;
    width: 100%;
    max-width: 1024px;
  }
  .tips{
        line-height: 50px;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background: #393939;
    color: #fff;
    text-align: center;
  }
</style>
<style>
.response-player object,
.response-player embed,
.response-player .vcp-player {
    position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
  }
.response-player .vcp-player video {
    width: 100%;
    height: 100%;
}
</style>
